<template>
	<div>
		<div id="non-printable">
			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

			    <v-toolbar-title class="white--text">{{toolbarTitle}}</v-toolbar-title>

			    <v-spacer></v-spacer>

			    <v-btn icon @click="fn_getReportData" v-if="listItemObject.totalCount"><v-icon>vertical_align_bottom</v-icon></v-btn>
			    <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>

			    <!-- <v-btn icon @click="fn_getBottomMenu(901)">
			      <v-icon>more_vert</v-icon>
			    </v-btn> -->

			    <div full-width slot="extension" :class="{'search-filter':isFilterApplicable, 'bottom-shadow':scrollPositionTop!=0}">
			    	<v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" @input="fn_debounceSearch"></v-text-field>
			    	<div v-if="isFilterApplicable" v-ripple class="filter-btn" @click="fn_openFilter">
			    		<v-icon>filter_list</v-icon>
			    		<span style="font-size: 48px;position: absolute;bottom: -14px;right: 6px;color: #4b77be;" v-if="selectionItems.typeFormId || selectionItems.orderChallanStatus!=1">&bull;</span>
			    	</div>
			    </div>
			</v-toolbar>

			<div class="hasToolbar hasExtension grey-back" v-scroll="onScroll">

				<div class="filter-display grey-back" v-if="listItemObject.totalCount">
					<v-layout row wrap>
						<v-flex xs6 sm6 md6>
							<div class="display-block white-background">
								<span font11 light-opacity-color>Count</span><br>
								<span font16 class="filter-display-value">{{$root.numberToLocale(listItemObject.totalCount, 1)}}</span>
							</div>
						</v-flex>
						<v-flex xs6 sm6 md6>
							<div class="display-block white-background">
								<span font11 light-opacity-color>Total Amount</span><br>
								<span font16 class="filter-display-value">&#8377; {{$root.numberToLocale(listItemObject.totalAmount)}}</span>
							</div>
						</v-flex>
					</v-layout>
				</div>


				<v-list grey-back two-line nopadding>

					<v-subheader white-background subheader-dense dark-opacity-color font-normal>
						<!-- Period:&nbsp;<span @click="fn_openDatePicker('start', starDate)">{{selectionItems.startDate | moment("DD-MMM-YYYY")}}</span>&nbsp;To&nbsp;<span @click="fn_openDatePicker('endDate', endDate)">{{selectionItems.endDate | moment("DD-MMM-YYYY")}}</span> -->
						<span @click="fn_openDialogCustomDates" v-if="selectionItems.selectedPeriod != 'All Time'">
							Period: {{selectionItems.startDate | moment("DD-MMM-YYYY")}} To {{selectionItems.endDate | moment("DD-MMM-YYYY")}}
						</span>
						<v-spacer></v-spacer>
						<v-menu v-model="dateMenu">
			                <v-btn justify-content-to-end style="height: 16px;" nomargin nopadding flat capitalize font-normal slot="activator">
			                	{{selectionItems.selectedPeriod}}&nbsp;<v-icon font20>date_range</v-icon></v-btn>
			                <v-list nopadding>
			                  <v-list-tile v-for="(item, index) in periods" :key="index" @click="fn_selectPeriod(item.value, {'title':item.title})">
			                      <v-list-tile-title>{{item.title}}</v-list-tile-title>
			                  </v-list-tile>
			                </v-list>
			            </v-menu>
						<!-- <v-icon font20 @click="fn_getReportData" v-if="listItemObject.totalCount">vertical_align_bottom</v-icon> -->
					</v-subheader>

					<v-divider></v-divider>

					<!-- <div v-if="listItemObject.totalCount">
						<v-divider></v-divider>
							<v-subheader subheader-dense color-light-grey>{{listItemObject.totalCount}} records</v-subheader>
						<v-divider></v-divider>
					</div> -->

					<div white-background v-for="(item, index) in listItemObject.items" :key="index" :class="{'margin-top-ten':index!=0}" :id="'item_'+item.transactionId">
						<v-list-tile class="right-subtitle-tile auto-height-tile" @click="fn_itemClick(item.transactionId, index)">
						    <v-list-tile-content>
						      <v-list-tile-title class="mb-1">{{item.accountLedgerName}}</v-list-tile-title>
						      <v-list-tile-sub-title class="mb-1">
						      	<!-- {{item.mergeTransactionNumber}} -->
						      	<span class="primary-color">{{item.mergeTransactionNumber}}</span>
						      	&nbsp;| {{item.transactionDate | moment("DD-MMM-YYYY")}}
						      </v-list-tile-sub-title>
							  <v-list-tile-sub-title class="mb-1" v-if="item.refNumber">
								Bill No. {{ item.refNumber }}
							  </v-list-tile-sub-title>
							  <v-list-tile-sub-title class="mb-1" v-if="$root.TransactionSettings.showPartyMobile && item.primaryMobileNumber">Ph: {{ item.primaryMobileNumber }}</v-list-tile-sub-title>
						    </v-list-tile-content>

						    <v-list-tile-action align-flex-end>

						    	<!-- <v-btn icon flat @click="fn_getBottomMenu(902, item.transactionId)" v-if="item.status">
						    		<v-icon>more_horiz</v-icon>
						    	</v-btn> -->
						    	
						    	<div class="warning-label" v-if="!item.status">Cancelled</div>

						    	<div v-else></div>

						    	<div>&#8377; {{$root.numberToLocale(item.roundedAmount)}}</div>

						    </v-list-tile-action>
						</v-list-tile>

						<!-- <v-divider v-if="listItemObject.items.length-1 != index"></v-divider> -->
						<v-divider v-if="item.invoiceTemplate"></v-divider>
						<div right-align style="padding:2px 6px" v-if="item.invoiceTemplate">
							<v-btn nomargin icon flat @click="fn_bindInvoiceTemplate('sharewhatsapp', item)"><img src="../../../../assets/icon_whatsapp.svg" style="width:20px" alt="whatapp_icon"></img></v-btn>
							<v-btn nomargin icon flat @click="fn_bindInvoiceTemplate('share', item)"><v-icon font20>share</v-icon></v-btn>
					    	<v-btn nomargin icon flat @click="fn_bindInvoiceTemplate('print', item)"><v-icon font20>print</v-icon></v-btn>
					    	<v-btn nomargin icon flat @click="fn_preview(item)">
					    		<img src="../../../../assets/icon_preview_black.svg" style="width:20px" alt="whatapp_icon"></img>
					    	</v-btn>
					    </div>
					</div>

					<!-- <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
						<div slot="no-more"></div>
						<div slot="no-results"></div>
					</infinite-loading> -->
					<!-- <div white-background padding-all-16 center-align v-if="loadMore">
			          <v-progress-circular indeterminate color="primary"></v-progress-circular>
			        </div> -->


				</v-list>

				<transition name="fade" mode="out-in">

					<v-card noshadow class="create-placeholder-card" v-if="showPlaceHolder && !listItemObject.totalCount">
						<v-card-text @click="fn_new">

							<div center-align>
				            	<div v-ripple class="placeholder-icon">
				            		<i aria-hidden="true" class="v-icon material-icons add-icon">add</i>
				            		<img src="../../../../assets/icon_wallet.svg" alt="">
				            	</div><br>

				            	<p class="title light-opacity-color">Create New {{toolbarTitle}}</p>
				            </div>
						</v-card-text>
					</v-card>
					
					<!-- <v-card noshadow v-if="showPlaceHolder && !listItemObject.totalCount" style="height: calc(100vh - 162px);display: flex;align-items: center;">
						<v-card-text>

							<div center-align>
				            	<div @click="fn_new" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
				            		<i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
				            		<img src="../../../../assets/icon_wallet.svg" style="opacity:0.6;width:42px" alt="">
				            	</div><br>

				            	<p class="title light-opacity-color" style="line-height:28px !important">Create New {{toolbarTitle}}</p>
				            </div>

						</v-card-text>
					</v-card> -->
				</transition>

				<!-- <div class="display_msg" v-if="!listItemObject.items.length">There are no items</div> -->
			</div>

			<!-- binding in the background to calculate full page height for header, body and footer -->
			<div id="hidden_invoice_preview" v-if="$root.TransactionSettings.fullPagePrint">
				<component :is="previewTemplate" ref="ref_previewTemplate" :data="printData" v-if="previewTemplate && printData!=null"></component>
			</div>
		</div>

		<div id="printable" full-width>
	      <component :is="printTemplate" ref="ref_printTemplate" :data="printData" v-if="printTemplate && printData!=null"></component>
	    </div>

		<dialog-filter-items ref="ref_dialogFilterItems" title="Filter By" :filterItems="filerItems" :setFilter="fn_setFilter" :selectedFilterItemId="selectionItems.orderChallanStatus"></dialog-filter-items>

		<dialog-transaction-type-list ref="ref_dialogTransactionTypeList" :transactionTypeId="settings.transactionTypeId" :setTransactionType="fn_setTransactionType" :selectedTypeFormId="selectionItems.typeFormId" :transactionTypeList="transactionTypeList" :hideNew="true" :clearAllBtn="true" :clearAll="fn_clearTransactionTypes"></dialog-transaction-type-list>

		<dialog-period-selection ref="ref_dialogCustomPeriod" title="Select Period" :openDatePicker="fn_openDatePicker" :startDate="selectedStartDate" :endDate="selectedEndDate" :actionMethod="fn_updateCustomDates"></dialog-period-selection>

		<dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>

		<dialog-month-filter ref="ref_dialogMonthFilter" :selectPeriod="fn_selectPeriod"></dialog-month-filter>
        <dialog-quarter-filter ref="ref_dialogQuarterFilter" :selectPeriod="fn_selectPeriod"></dialog-quarter-filter>
		<dialog-fy-filter ref="ref_dialogFiscalYearFilter" :selectPeriod="fn_selectPeriod"></dialog-fy-filter>

		<dialog-drive-alert ref="ref_dialogDriveAlert"></dialog-drive-alert>

		<v-snackbar v-model="snackbar">
          File downloaded!
          <v-btn flat color="primary" @click.native="$root.fn_openDownloadedFile">Open</v-btn>
        </v-snackbar>

        <v-snackbar v-model="infoSnackbar">
          Selected period is not applicable!
          <v-btn text color="primary" @click.native="infoSnackbar=false">Close</v-btn>
        </v-snackbar>
	</div>
</template>

<script>
var tagId = null;
const menuItem = require('../../../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../../../config.js').configs.bottomSheetMenu;
const transactionForms = require('../../../../config.js').configs.transactionForms;
const transactionTypes = require('../../../../config.js').configs.transactionTypes;

const dialogjs =  require('../../../masters/forms/dialog').dialogjs;

// import InfiniteLoading from 'vue-infinite-loading';
import dialogFilterItems from '../../../dialogs/dialog_filter_items';
import dialogTransactionTypeList from '../dialogs/dialog_transaction_type_list';

import dialogDriveAlert from '../dialogs/dialog_drive_alert'
import dialogPeriodSelection from '../../../dialogs/dialog_period_selection'
import dialogDatePicker from './dialogs/dialog_datepicker';
import dialogMonthFilter from '../../../dialogs/dialog_filter_months'
import dialogQuarterFilter from '../../../dialogs/dialog_filter_quarter'
import dialogFyFilter from '../../../dialogs/dialog_filter_fiscalyear'

import {exportExcelMixin} from '../../export_excel_mixin'
import {transactionMixin} from '../../transaction_mixin'

	export default{
		props:['settings'],
		mixins: [exportExcelMixin, transactionMixin],
		components: {
		    // InfiniteLoading,
		    'dialog-filter-items': dialogFilterItems,
		    'dialog-transaction-type-list': dialogTransactionTypeList,
		    'dialog-drive-alert':dialogDriveAlert,
		    'dialog-period-selection':dialogPeriodSelection,
		    'dialog-datepicker': dialogDatePicker,
		    'dialog-month-filter': dialogMonthFilter,
    		'dialog-quarter-filter': dialogQuarterFilter,
			'dialog-fy-filter':dialogFyFilter
		},
		data(){
			return{
				toolbarTitle:null,
				listItemObject:{"items":[], "totalCount":0, "totalAmount":null},
				searchValue:'',
				infiniteId: +new Date(),
				startIndex:0,
				scrollPositionTop:0,
				selectedItemId:null,
				filerItems:[
					{"filterItemId":1, "name":"All", "value":null},
					{"filterItemId":2, "name":"Pending", "value":'pending'},
					{"filterItemId":3, "name":"Close", "value":'close'}
				],
				// selectionItems.orderChallanStatus:1,
				isFilterApplicable:false,
				transactionTypeList:null,
				// selectionItems.typeFormId:null,
				selectionItems:{
					typeFormId:null,
					orderChallanStatus:1,
					startDate:this.$root.minDateSelection,
		        	endDate:this.$root.maxDateSelection,
		        	selectedPeriod:"All Time"
				},
				loadMore:false,
				backButtonPress:false,
				dateType:null,
				selectedDate:null,
		        snackbar:false,
		        printData:null,
        		printTemplate:null,
				previewTemplate:null,
        		showPlaceHolder:false,
        		formId:null,
				dialogStorageId:null,
				dateMenu:false
			}
		},
		methods:{

			fn_preview: function(item){
		        item.toolbarTitle = this.toolbarTitle;
		        let printType = null;
		        this.fn_previewInvoice(true, 'purchase', printType, item);
		    },

		    fn_bindInvoiceTemplate: function(type, item){

		        this.printTemplate = null;
		        this.printData = null;
				this.previewTemplate = null;

		        // this.printTemplate = require('../../../invoice_templates/invoices/template'+ item.invoiceTemplate).default;
		        this.previewTemplate = require('../../../invoice_templates/invoices/template'+item.invoiceTemplate).default;
				if(this.$root.TransactionSettings.fullPagePrint){
					this.printTemplate = require('../../../invoice_templates/invoices/template1001').default;
				}
				else{
					this.printTemplate = require('../../../invoice_templates/invoices/template'+item.invoiceTemplate).default;
				}
				console.log(this.printTemplate);

		        let dataFnName = 'InvoiceData';

		        if(type=='sharewhatsapp'){
		          this.fn_shareInvoice('sharewhatsapp', item, dataFnName);
		        }
		        else if(type=='print'){
		          this.fn_getPrintData(dataFnName, item.transactionId, 'print', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
		        }
		        else if(type=='pdf'){
		          this.fn_getPrintData(dataFnName, item.transactionId, 'pdf', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
		        }
		        else if(type=='share'){
		          this.fn_shareInvoice('share', item, dataFnName);
		        }

				setTimeout(() => {
					this.previewTemplate = null;
				}, 5000);
		    },

		    fn_shareInvoice: function(type, item, dataFnName){
		        let shareObj = {};
		        shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
		        shareObj.type = 'pdf';
		        shareObj.primaryMobileNumber = item.primaryMobileNumber && type == 'sharewhatsapp' ? item.primaryMobileNumber : null;
		        // shareObj.subject = this.toolbarTitle + " Details";
				shareObj.subject = this.toolbarTitle + " #" + item.mergeTransactionNumber + " from " + this.$root.CurrentBusiness.BusinessName;
		        shareObj.email = item.email ? [item.email] : null ;

		        let party = item.accountLedgerName ? item.accountLedgerName + ',' : '';

        		// shareObj.textMessage = "Dear "+party+"\n\nBelow are your " + this.toolbarTitle + " details. Please find the attached pdf.\n\nTransaction Date: "+this.$moment(item.transactionDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(item.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
        		shareObj.textMessage = this.$tShare('share.invoiceMessage', {
        			party: party,
        			title: this.toolbarTitle,
        			number: item.mergeTransactionNumber,
        			date: this.$moment(item.transactionDate).format('DD-MMM-YYYY'),
        			amount: this.$root.numberToLocale(item.roundedAmount),
        			businessName: this.$root.CurrentBusiness.BusinessName
        		});

		        // shareObj.textMessage = "Dear "+item.accountLedgerName+",\n\nBelow are your invoice details. Please find the attached pdf of your invoice.\n\nInvoice Date: "+this.$moment(item.createdDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(item.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
		        this.fn_getPrintData(dataFnName, item.transactionId, 'pdf', shareObj, item.mergeTransactionNumber, null, item.transactionListId);
		    },

			onScroll (event) {
		        var element = event.target;
		        if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 150 <= element.documentElement.clientHeight)
		        {
		            console.log('scrolled');
		            if(this.listItemObject.items.length < this.listItemObject.totalCount){
		              this.fn_loadItems();
		            }
		        }
		    },

			fn_setFilter: function(filterItemId){
				this.selectionItems.orderChallanStatus = filterItemId;
				localStorage.setItem('transaction_filter', JSON.stringify(this.selectionItems));
				this.fn_closeDialog();
				this.fn_searchItem();
			},
			fn_openFilter: function(){
				this.dateMenu = false;
				if(this.settings.transactionTypeId == transactionTypes.purchaseOrder.id || this.settings.transactionTypeId == transactionTypes.purchaseChallan.id){
					this.fn_openDialogFilterItems();
				}
				else{
					this.fn_openTransactionTypeList();
				}
			},
			fn_openDialogFilterItems: function(){
				this.fn_openDialogWeb('web', 'FilterItems', 'ref_dialogFilterItems');
				// this.$refs['ref_dialogFilterItems'].openDialogWeb();
			},
			fn_openTransactionTypeList: function () {
				this.fn_openDialogWeb('web', 'TransactionTypeList', 'ref_dialogTransactionTypeList');
				// this.$refs['ref_dialogTransactionTypeList'].dialog_transactionTypeList = true;
			},

			fn_closeDialog: function(){
				this.$refs['ref_dialogFilterItems'].dialog_filter_items = false;
				this.$refs['ref_dialogTransactionTypeList'].dialog_transactionTypeList = false;
				this.$refs['ref_dialogDatePicker'].datepicker = false;
				this.$refs['ref_dialogQuarterFilter'].dialog_filter_quarter = false;
            	this.$refs['ref_dialogMonthFilter'].dialog_filter_month = false;
			},
			fn_getTransactionTypeList: function () {
		        let filterObject = {};
		        filterObject.type = this.settings.transactionTypeId;
		        filterObject.accountGroupsHidden = [2];
		        // filterObject.inventory = [0, 1];

		        let self = this;
		        this.getItems("TransactionTypeList", filterObject, 
		          {
		            onSuccess: function (response) {
		              	console.log(response);
		              	self.transactionTypeList = JSON.parse(response);
		            },
		            onError: function (error) {
		              console.log(error);
		            }
		          }
		        )
		    },
		    fn_setTransactionType: function(item){
		    	this.selectionItems.typeFormId = item.transactionTypeFormId;
		    	localStorage.setItem('transaction_filter', JSON.stringify(this.selectionItems));
		    	this.fn_closeDialog();
		    	this.fn_searchItem();
		    },
		    fn_clearTransactionTypes: function(){
		    	this.selectionItems.typeFormId = null;
		    	localStorage.setItem('transaction_filter', JSON.stringify(this.selectionItems));
		    	this.fn_closeDialog();
		    	this.fn_searchItem();
		    },
			fn_drafts: function(){
				this.$router.push({path:'/drafts', query:{tabIndex:1}});
			},
			fn_initializeSettings: function () {
				transactionForms.filter(item => {
					if(item.id == this.settings.transactionTypeId){
						this.toolbarTitle = item.title;
					}
				})

				if(this.$route.path.indexOf('debitnote') != -1){
					this.toolbarTitle = 'Debit Note';
				}
			},
			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			},
			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='new'){
					// this.fn_new();
				}
				else if(menuAction=='edit'){
					this.$router.push('/transactions/purchase/'+this.toolbarTitle.toLowerCase().replace(/ /g,'')+'/items/'+this.selectedItemId+'/edit');
				}
				else if(menuAction=='copy'){
					this.$router.push({path:"/transactions/purchase/"+this.toolbarTitle.toLowerCase().replace(/ /g,'')+"/items/new", query:{tagId:this.guidWeb(), itemId:this.selectedItemId, copy:true}});
				}
				else if(menuAction=='draft'){
					// this.$router.push({path:'/drafts', query:{category:this.toolbarTitle}});
				}
			},

			// fn_checkDrive: function(){
		 //        let self = this;
		 //        if(this.$root.CurrentBusiness.DataDrive){
		 //          this.fn_new();
		 //        }
		 //        else{
		 //          this.$root.fn_getTransactionCount(function(count){
		 //            if(count>=10){
		 //              self.$refs['ref_dialogDriveAlert'].dialog_setup_drive = true;
		 //            }
		 //            else{
		 //              self.fn_new();
		 //            }
		 //          })
		 //        }
		 //    },

			fn_new: function () {
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = this.listItemObject.items.length;
				localStorage.setItem("transaction_items_state", JSON.stringify(obj));

				localStorage.setItem("SetDataDrive", 1);
				this.$router.push({path:'/transactions/purchase/'+this.toolbarTitle.toLowerCase().replace(/ /g,'')+'/items/new', query:{tagId:this.guidWeb()}});
			},

			fn_itemClick: function (itemId, index) {
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("transaction_items_state", JSON.stringify(obj));
				// tagId id form future use
				// itemName id form future use
				this.$router.push('/transactions/purchase/'+this.toolbarTitle.toLowerCase().replace(/ /g,'')+'/items/'+itemId);
			},

			fn_getBottomMenu: function (elementId, itemId) {
				itemId ? this.selectedItemId = itemId : '';

				let bottomMenu;

				// if(elementId == bottomSheetMenu.toolBar.Id){
				// 	bottomMenu = {"BottomMenu": [menuItem.help]};
				// }
				if(elementId == bottomSheetMenu.masterListItems.Id){
					bottomMenu = {"BottomMenu": [menuItem.edit]};
				}
				
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			// infiniteHandler($state) {
		 //    	let filterObject = {};
			// 	filterObject.type = this.settings.transactionTypeId;
			// 	filterObject.limit = 10;
			// 	filterObject.startIndex = this.startIndex;
			// 	filterObject.search = this.searchValue.toLowerCase();

			// 	// filterObject.itemFilter = {"open":false, "close":false, "all":false};
			// 	filterObject.itemFilter = {};
			// 	if(this.settings.transactionTypeId == transactionTypes.purchaseOrder.Id || this.settings.transactionTypeId == transactionTypes.purchaseChallan.Id){
			// 		this.selectionItems.orderChallanStatus == 1 ? filterObject.itemFilter.all = true : this.selectionItems.orderChallanStatus == 2 ? filterObject.itemFilter.open = true : filterObject.itemFilter.close = true;
			// 	}
			// 	this.selectionItems.typeFormId ? filterObject.itemFilter.transactionTypeForms = [this.selectionItems.typeFormId] : '';
			// 	alert('out')
			// 	let self = this;
			// 	this.getItems("AccountBookList", filterObject, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 				let responseJson = JSON.parse(response);
			// 				self.listItemObject.totalCount = responseJson.totalCount;

			// 				for(let i in responseJson.items){
			// 					self.listItemObject.items.push(responseJson.items[i]);	
			// 				}

			// 				self.startIndex = self.listItemObject.items.length;

			// 				if(self.listItemObject.items.length < self.listItemObject.totalCount){
			// 					$state.loaded();
			// 					alert('loaded')
			// 				}
			// 				else {
   //        						$state.complete();
   //        						alert('complete')
   //      					}
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
		 //    },

			// fn_searchItem: function () {
			// 	this.startIndex = 0;
			// 	this.infiniteId += 1;
			// 	this.listItemObject.items = [];
			// },

			fn_loadItems: function(search) {
		    	let filterObject = {};
				filterObject.type = this.settings.transactionTypeId;
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = this.searchValue ? this.searchValue.toLowerCase() : '';
				// filterObject.startDate = new Date(this.selectionItems.startDate);
				filterObject.startDate = this.$moment(this.selectionItems.startDate).startOf('day');
				filterObject.endDate = this.$moment(this.selectionItems.endDate).endOf('day');

				filterObject.startDate = this.$root.fn_getLocalDateFormat(filterObject.startDate);
		        filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

				//formTransactionListId will use in case of delivery challan or order to check pending or complete items
				if(this.settings.transactionTypeId == transactionTypes.purchaseOrder.id){
					filterObject.formTransactionListId = [transactionTypes.purchaseChallan.id, transactionTypes.purchaseInvoice.id]
				}
				else if(this.settings.transactionTypeId == transactionTypes.purchaseChallan.id){
					filterObject.formTransactionListId = [transactionTypes.purchaseInvoice.id]
				}

				filterObject.itemFilter = {};
				if(this.settings.transactionTypeId == transactionTypes.purchaseOrder.id || this.settings.transactionTypeId == transactionTypes.purchaseChallan.id){
					this.selectionItems.orderChallanStatus == 1 ? filterObject.itemFilter.all = true : this.selectionItems.orderChallanStatus == 2 ? filterObject.itemFilter.open = true : filterObject.itemFilter.close = true;
				}
				this.selectionItems.typeFormId ? filterObject.itemFilter.transactionTypeForms = [this.selectionItems.typeFormId] : '';

				let pageState = null;
				if(localStorage.getItem("transaction_items_state")){
					pageState = JSON.parse(localStorage.getItem("transaction_items_state"));
					filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
				}

				if(this.toolbarTitle == 'Debit Note'){
					filterObject.isCreditDebitNote = true;
				}

				let self = this;
				this.getItems("AccountBookList", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
			              	let responseJson = JSON.parse(response);
			              	self.listItemObject.totalCount = responseJson.totalCount;
			              	self.listItemObject.totalAmount = responseJson.totalAmount;

			              	search ? self.listItemObject.items = [] : '';

			              	let itemFound = false;
			              	for(let i in responseJson.items){
								
								if(responseJson.items[i].transactionPhoneNumber){
									responseJson.items[i].primaryMobileNumber = responseJson.items[i].transactionPhoneNumber; 
								}

			              		if(pageState && pageState.itemId){
									if(responseJson.items[i].transactionId == pageState.itemId){
										itemFound = true;
									}
									// else{
									// 	itemFound = false;
									// }
								}
								// else{
								// 	itemFound = true;
								// }

								let itemIndex = self.listItemObject.items.findIndex(item => item.transactionId==responseJson.items[i].transactionId);

								if(itemIndex==-1){
									self.listItemObject.items.push(responseJson.items[i]);	
								}

			                	// self.listItemObject.items.push(responseJson.items[i]);  
			              	}

			              	console.log(pageState);
							if(pageState && pageState.itemId){
								setTimeout(function(){
									if(itemFound){
										let scrollOptions = {"duration":0, "offset":-112, "easing":"linear"};
										self.$vuetify.goTo('#item_'+pageState.itemId, scrollOptions);
										localStorage.removeItem("transaction_items_state");
									}
									else{
										self.$vuetify.goTo(99999, self.scrollOptions);
									}
								},100);
							}

							if(pageState && !pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":300, "offset":-112, "easing":"linear"};
									self.$vuetify.goTo(pageState.lastScrollPos, scrollOptions);
									localStorage.removeItem("transaction_items_state");
								},100);
							}

			              	self.startIndex = self.listItemObject.items.length;
			              	self.loadMore = false;

			              	setTimeout(function(){
								self.showPlaceHolder = true;
							},300);
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    },


			fn_searchItem: function () {
	        	this.startIndex = 0;
	        	this.listItemObject.items = [];
	        	this.fn_loadItems(true);
	      	},

	      	fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_showWebView: function () {
				let viewObject = {};
				let self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},
		},
		mounted: function(){

			tagId = this.$route.query.tagId;

			this.formId = this.$route.query.tagId;
			this.dialogStorageId = "dialog_"+this.formId;

			this.fn_initializeSettings();

			this.fn_showWebView();
			window.js_globals.fn_onBackPress = this.fn_goBack;

			let self = this;
			document.addEventListener('scroll', function () {
				self.scrollPositionTop = window.pageYOffset
			})

			if(this.settings.transactionTypeId == transactionTypes.purchaseOrder.id || this.settings.transactionTypeId == transactionTypes.purchaseChallan.id || this.settings.transactionTypeId == transactionTypes.purchaseInvoice.id){
				this.isFilterApplicable = true;
				this.settings.transactionTypeId == transactionTypes.purchaseInvoice.id ? this.fn_getTransactionTypeList() : '';
			}

			this.$root.fn_getLocalData('selected_date_filter', response=>{
				let data = JSON.parse(response);

				if(localStorage.getItem('transaction_filter')){
					let data = JSON.parse(localStorage.getItem('transaction_filter'));
					this.selectionItems.typeFormId = data.typeFormId;
					this.selectionItems.orderChallanStatus = data.orderChallanStatus;
					// this.selectionItems.startDate = new Date(data.startDate);
					// this.selectionItems.endDate = new Date(data.endDate);
					// this.selectionItems.selectedPeriod = data.selectedPeriod;
				}
				
				if(data && data.type){
					let period = this.periods.filter(item =>{
						return item.value == data.type;
					})

					if(period && period.length){
						this.fn_selectPeriod(period[0].value, {'title':period[0].title});
					}
					else{
						this.fn_selectPeriod(data.type, data.month, data.year);
					}
				}
				else{
					this.fn_loadItems();
				}
				// else{
				// 	if(data){
				// 		this.selectionItems.startDate = data.startDate;
				// 		this.selectionItems.endDate = data.endDate;
				// 		this.selectionItems.selectedPeriod = data.label;
				// 	}
				// }

				// this.fn_loadItems();
              
            })

			// if(localStorage.getItem('transaction_filter')){
			// 	let data = JSON.parse(localStorage.getItem('transaction_filter'));
			// 	this.selectionItems.typeFormId = data.typeFormId;
			// 	this.selectionItems.orderChallanStatus = data.orderChallanStatus;
			// 	this.selectionItems.startDate = new Date(data.startDate);
			// 	this.selectionItems.endDate = new Date(data.endDate);
			// 	this.selectionItems.selectedPeriod = data.selectedPeriod;
			// }

			this.myworker.addEventListener('message', event => {
	            self.fn_breakDataIntoChunks(event);
	        });
		},
		beforeRouteEnter(to, from, next){
			next(vm => {
				if(from.name == 'actions'){
					localStorage.removeItem("transaction_items_state");
				}	
			});
		},
		beforeRouteLeave(to, from, next){
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					next(true);
				}
			}
			else{
				this.backButtonPress ? localStorage.removeItem('transaction_filter') : '';
				next(true);
			}
			// if(this.$refs['ref_dialogFilterItems'].dialog_filter_items || this.$refs['ref_dialogTransactionTypeList'].dialog_transactionTypeList || this.$refs['ref_dialogDatePicker'].datepicker || this.$refs['ref_dialogQuarterFilter'].dialog_filter_quarter || this.$refs['ref_dialogMonthFilter'].dialog_filter_month){
			// 	this.$refs['ref_dialogFilterItems'].dialog_filter_items = false;
			// 	this.$refs['ref_dialogTransactionTypeList'].dialog_transactionTypeList = false;
			// 	this.$refs['ref_dialogDatePicker'].datepicker = false;
			// 	this.$refs['ref_dialogQuarterFilter'].dialog_filter_quarter = false;
   //          	this.$refs['ref_dialogMonthFilter'].dialog_filter_month = false;
			// 	this.backButtonPress = false;
			// 	next(false);
			// }
			// else{
			// 	this.backButtonPress ? localStorage.removeItem('transaction_filter') : '';
			// 	next();
			// }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/purchase/items.vue